export type DocumentLanguageCode = 'ar' | 'en' | 'he';

export const DEFAULT_DOCUMENT_LANGUAGE_STORAGE_KEY = 'defaultDocumentLanguage';
export const FALLBACK_DOCUMENT_LANGUAGE: DocumentLanguageCode = 'he';

export function getDefaultDocumentLanguage(): DocumentLanguageCode {
	const stored = localStorage.getItem(DEFAULT_DOCUMENT_LANGUAGE_STORAGE_KEY);
	if (stored === 'ar' || stored === 'en' || stored === 'he') {
		return stored;
	}
	return FALLBACK_DOCUMENT_LANGUAGE;
}

export function setDefaultDocumentLanguage(code: string): DocumentLanguageCode {
	const next = code === 'ar' || code === 'en' || code === 'he' ? code : FALLBACK_DOCUMENT_LANGUAGE;
	localStorage.setItem(DEFAULT_DOCUMENT_LANGUAGE_STORAGE_KEY, next);
	return next;
}
